import { useState, useEffect } from 'react'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import { PageTitle } from '../../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import { Col, Dropdown, Modal, Row, Spinner } from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import usePagination from 'utils/hooks/usePagination'
import { toast } from 'react-toastify'
import FormGenerator from '../../../../utils/helpers/FormGenerator'
import Api from '../../../../thesis-and-dissertations/helpers/api'
const api = new Api();

const heads = [
  {
    name: '',
    label: 'Tipe',
  },
  {
    name: '',
    label: 'Judul',
  },
  {
    name: '',
    label: 'Deskripsi',
  },
  {
    name: '',
    label: 'Gambar',
  },
  {
    name: '',
    label: 'Aksi',
  },
]

const inputs = [
  {
    name: 'tipe',
    label: 'Tipe',
    type: 'text',
    validation: {},
    col: 12,
    options: [],
    additional: '',
  },
  {
    name: 'title_id',
    label: 'Judul',
    type: 'text',
    validation: {},
    col: 12,
    options: [],
    additional: '',
  },
  {
    name: 'deskripsi_id',
    label: 'Deskripsi',
    type: 'rich-text',
    validation: {},
    col: 12,
    options: [],
    additional: '',
  },
  {
    name: 'is_active',
    label: 'Status',
    type: 'select',
    validation: {},
    col: 12,
    options: [
      {
        name: 'Pilih Status',
        value: '',
      },
      {
        name: 'Aktif',
        value: '1',
      },
      {
        name: 'Non-Aktif',
        value: '0',
      },
    ],
    getItemValue: 'name',
    getItemValueId: 'value',
    additional: '',
  },
  {
    name: 'file',
    label: 'Gambar',
    type: 'file',
    validation: {},
    col: 12,
    options: [],
    additional: '',
  },
]

const ThesisDisertationContentPagePage = () => {
  const [thesis, setThesis] = useState([])
  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_row: 10,
  })

  const [show, setShow] = useState(false)
  const [formValue, setFormValue] = useState({})
  const [query, setQuery] = useState({});

  useEffect(() => {
    fetchThesis({ ...query })
  }, [query])

  const toggle = () => {
    if (show) {
      setFormValue({})
    }
    setShow(!show)
  }

  const fetchThesis = (params = {}) => {
    setIsLoading(true);
    api.getMasterTable({ ...params })
      .then(response => {
        setIsLoading(false);
        const data = response.data;
        let pagination = {};
        pagination.per_page = data.data.per_page;
        pagination.page = data.data.current_page;
        pagination.total_page = data.data.total;
        pagination.total_row = data.data.total;

        setThesis(data.data.data);
        setPagination(pagination);
      }).catch((error) => {
        const { data } = error.response;
        setErrors(data?.meta?.error);
        setIsLoading(false);
      });
  };

  const paginator = usePagination({
    totalCount: pagination?.total_row,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })

  const onChangePerPage = (per_page, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page,
    })

    fetchThesis({
      ...query,
      per_page: per_page,
      page: to_page,
    })
  }

  const onChange = (e) => {
    const { name, value, files } = e.target

    if (name == 'file') {
      setFormValue({ ...formValue, image: files[0] })
      return
    }

    setFormValue({ ...formValue, [name]: value })
  }

  const onSubmit = async (e) => {
    e?.preventDefault()
    if (formValue?.id) {
      actionUpdate()
      return
    }

    actionCreate()
  }

  const actionCreate = () => {
    setIsLoading(true)
    api.storeMasterTable({ title_en: 'title_en', deskripsi_en: 'description_en', ...formValue })
      .then(response => {
        setIsLoading(false)
        toggle()
        toast.success(response?.data?.meta?.message)
        fetchThesis()
      }).catch((error) => {
        const { data, status } = error.response
        setErrors(data?.meta?.error)
        setIsLoading(false)
        toast.error(data.meta.message)
      })
  }

  const actionUpdate = () => {
    setIsLoading(true)
    api.updateMasterTable({ title_en: 'title_en', deskripsi_en: 'description_en', ...formValue }, formValue?.id)
      .then(response => {
        setIsLoading(false)
        toggle()
        toast.success(response?.data?.meta?.message)
        fetchThesis()
      }).catch((error) => {
        const { data, status } = error.response
        setErrors(data?.meta?.error)
        setIsLoading(false)
        toast.error(data.meta.message)
      })
  }

  return (
    <>
      <div className='row'>
        <Modal show={show} onHide={toggle} size='lg'>
          <Modal.Header closeButton>
            <Modal.Title>DETAIL {formValue?.title_id}</Modal.Title>
          </Modal.Header>
          <Form onSubmit={onSubmit}>
            <Modal.Body>
              <Row>{FormGenerator(inputs, formValue, onChange)}</Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant='secondary' onClick={toggle}>
                Batalkan
              </Button>
              <Button variant='primary' type='submit' disabled={isLoading}>
                {isLoading ? 'Loading' : 'Simpan'}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        <div className='col-md-12'>
          <div className='card-custom'>
            <Row>
              <Col md={{ span: 4 }}>
                <Form.Control
                  placeholder='Cari...'
                  name='q'
                  onChange={(e) =>
                    setQuery({ ...query, q: e.target.value })}
                />
              </Col>
              <Col md={{ span: 2, offset: 4 }} >
                {/* <Button type='button' onClick={toggle} className='form-control'>
                  {'  '}+ Tambah
                </Button> */}
              </Col>
              <Col md={{ span: 2 }}>
                <Form.Select
                  aria-label='Default select example'
                  className='mr-8'
                  onChange={(e) => {
                    setQuery({ ...query, sort_order: e.target.value })
                  }}
                >
                  <option value='desc'>Terbaru</option>
                  <option value='asc'>Terlama</option>
                </Form.Select>
              </Col>
            </Row>

            <Row md={12} className='mt-8'>
              <Table responsive className='table-striped align-middle'>
                <thead>
                  <tr>
                    <th>#</th>
                    {heads.map((item, index) => (
                      <th key={index} style={{ maxWidth: item.label == 'Aksi' ? '100px' : '' }}>
                        {item.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {
                    thesis?.map((item, key) => {
                      return (
                        <tr key={key}>
                          <td>{key + 1}</td>
                          <td>{item?.tipe}</td>
                          <td>{item?.title_id}</td>
                          <td>{item?.deskripsi_id}</td>
                          <td><img src={item?.image} alt={item?.title_id} width={50} height={50} /></td>
                          <td>
                            {item.is_active == 0 ? (
                              <Button
                                variant='secondary'
                                className='shadow-none btn-sm btn-sm btn-outline btn-outline-dark'
                              >
                                Non-Aktif
                              </Button>
                            ) : (
                              <Button
                                className='shadow-none btn btn-sm btn-outline btn-outline-success'
                                variant='outline'
                              >
                                Aktif
                              </Button>
                            )}
                          </td>
                          <td>
                            <Button
                              className='btn-sm'
                              onClick={() => {
                                setFormValue({
                                  tipe: item?.tipe,
                                  title_id: item?.title_id,
                                  deskripsi_id: item?.deskripsi_id,
                                  // image: item?.image,
                                  is_active: item?.is_active,
                                  id: item?.id,
                                })
                                toggle()
                              }}
                            >
                              Edit
                            </Button>
                          </td>
                        </tr>
                      )
                    })
                  }
                </tbody>
              </Table>
            </Row>

            <Row>
              <Col md={6}>
                {thesis?.length > 0 && !isLoading && (
                  <div style={{ float: 'left' }}>
                    <Dropdown>
                      <Dropdown.Toggle className='btn btn-sm'>
                        {pagination.per_page}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {[10, 25, 50, 100].map((item) => (
                          <Dropdown.Item
                            key={item}
                            onClick={() => onChangePerPage(item)}
                            disabled={pagination.per_page === item}
                          >
                            {item}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </Col>
              <Col md={6}>
                <div style={{ float: 'right' }}>
                  {!isLoading && (
                    <Pagination className='btn-sm'>
                      {paginator?.map((item) => {
                        return (
                          <Pagination.Item
                            className='btn-sm'
                            key={item}
                            active={item === pagination.page}
                            onClick={() => onChangePerPage(pagination.per_page, item)}
                            disabled={item === '...'}
                          >
                            {item}
                          </Pagination.Item>
                        )
                      })}
                    </Pagination>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  )
}

const ThesisDisertationContentPage = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Daftar Tesis & Disertasi
      </PageTitle>
      <ThesisDisertationContentPagePage />
    </>
  )
}

export default ThesisDisertationContentPage
